var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSetImport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 10 12.5",
    style: {
      enableBackground: "new 0 0 10 12.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,0c0.2,0,0.4,0.1,0.6,0.4s0.5,0.6,0.7,0.9S7,2,7.3,2.3S7.9,3,8.1,3.4c0.3,0.3,0.5,0.7,0.8,1 c0.2,0.3,0.3,0.6,0.3,0.8C9.1,5.3,8.9,5.4,8.6,5.4c-0.2,0-0.4,0-0.7,0c-0.3,0-0.5,0-0.8,0c-0.2,0-0.4,0.1-0.4,0.2S6.6,6,6.6,6.2 c0,0.3,0,1.6,0,3.9l-2.9,0c0-2,0-3.2,0-3.6c0-0.4,0-0.6-0.1-0.8C3.5,5.5,3.4,5.4,3.1,5.4c-0.2,0-0.4,0-0.7,0c-0.3,0-0.5,0-0.7,0 c-0.3,0-0.5-0.1-0.6-0.2C1,5,1.1,4.8,1.3,4.5s0.5-0.6,0.7-0.9c0.3-0.3,0.6-0.7,0.9-1.1c0.3-0.4,0.6-0.7,0.9-1.1s0.5-0.7,0.8-1 C4.8,0.1,5,0,5.2,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.5,11.5h9c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-9C0.2,12.5,0,12.3,0,12S0.2,11.5,0.5,11.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSetImport);
export default __webpack_public_path__ + "static/media/location_set_import.a795f469b630c32c48edf383a1a3b2a2.svg";
export { ForwardRef as ReactComponent };